module.exports = __webpack_public_path__ + "media/images/email/time-4934d151d04397766be827c595739ece.svg";